import get from 'lodash/get'

import { ThemeInterfaceKeys } from './theme'

export const SPACING_MULTIPLIER = 4
/**
 * This utility is for use on margins and padding, but shouldn't necessarily use this to form
 * height and width values.
 */
export const space = (
  num: number = 1,
  suffix: boolean = true
): string | number => {
  if (num % 1 !== 0) {
    throw new Error('An integer must be passed.')
  }
  return suffix ? `${num * SPACING_MULTIPLIER}px` : num * SPACING_MULTIPLIER
}

export const theme = (keys: ThemeInterfaceKeys) => (props: any) =>
  get(props, `theme.${keys}`)
